export type ProjectType = 'newsletter' | 'hey_genius' | 'new_video';

export type MediaPlayerTimedEvent = {
  time: number; // legacy
  current_time: number;
  /** Time spent watching the media in seconds. */
  watch_time: number;
  /** Time spent skipping the media in seconds. */
  skipped_time: number;
  /** Duration of the media in seconds. */
  duration: number;
  /** Completion rate of the media. From 0 to 100. */
  completion_rate: number;
  /** Playback rate (speed) of the media player. Default is 1. */
  playback_rate: number;
};

export enum MediaAnalyticsEvents {
  /** The media player is first loaded and visible. */
  MediaPlayerImpressionEvent = 'media_player_impression',
  MediaPlayerPlayEvent = 'media_player_play',
  MediaPlayerSeekEvent = 'media_player_seek',
  MediaPlayerPausedEvent = 'media_player_pause',
  MediaPlayerResumedEvent = 'media_player_resume',
  MediaPlayerCompletedEvent = 'media_player_ended',
  MediaPlayerHeartbeatEvent = 'media_player_heartbeat',
  /** The playback rate (speed) of the media player was changed. */
  MediaPlayerPlaybackRateChangeEvent = 'media_player_playback_rate_change',
}

/** How often (ms) to send a heartbeat while the page is actively engaged. */
export const PAGE_ENGAGEMENT_HEARTBEAT_INTERVAL = 30_000;

/**
 * Single event used for all page engagement signals:
 * - Fired immediately on mount (active_time: 0) — captures bounces
 * - Fired every PAGE_ENGAGEMENT_HEARTBEAT_INTERVAL seconds while the tab is visible
 * - Fired on pagehide/beforeunload as the final flush
 *
 * One event type keeps the schema simple: query MAX(active_time) per session
 * to get total time on page.
 */
export enum PageEngagementEvents {
  PageEngagementHeartbeat = 'page_engagement_heartbeat',
}

export type PageEngagementProperties = {
  /** Total seconds since the component mounted (wall clock). */
  time_on_page: number;
  /** Seconds the tab was in the foreground (document.visibilityState === 'visible'). */
  active_time: number;
  /** Seconds the tab was hidden (backgrounded / minimized). */
  hidden_time: number;
};

export type PageEngagementEventsWithProperties = {
  [PageEngagementEvents.PageEngagementHeartbeat]: PageEngagementProperties;
};

export type MediaEventsWithProperties = {
  [MediaAnalyticsEvents.MediaPlayerPausedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerSeekEvent]: MediaPlayerTimedEvent & {
    seek_start: number;
    seek_end: number;
  };
  [MediaAnalyticsEvents.MediaPlayerResumedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerCompletedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerPlayEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerHeartbeatEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerPlaybackRateChangeEvent]: MediaPlayerTimedEvent;
};

// dummy change to force new docs
